import { render, staticRenderFns } from "./DeleteResourceAuditFlow.vue?vue&type=template&id=20451a68&scoped=true"
import script from "./DeleteResourceAuditFlow.vue?vue&type=script&lang=js"
export * from "./DeleteResourceAuditFlow.vue?vue&type=script&lang=js"
import style0 from "./DeleteResourceAuditFlow.vue?vue&type=style&index=0&id=20451a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20451a68",
  null
  
)

export default component.exports